<template>
  <div id="app">
    <PasswordReset/>
  </div>
</template>

<script>
import PasswordReset from './components/PasswordReset.vue';

export default {
  name: 'App',
  components: {
    PasswordReset
  }
};
</script>

<style>
</style>
